import React, { useEffect, useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import allreportsdata from "../../../json-data/allreports.json";
import allReportsHindidata from "../../../json-data/allReportsHindi.json";
import { fetchArchiveServicesCWSNEnrolmentData } from "../../../redux/thunks/archiveServicesThunk";
import {
  initialFilterEnrolmentData,
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  district,
  districtWiseName,
  blockWiseName,
  block,
  generateTextContent,
  foundational_preparatory,
  middle,
  secondary,
} from "../../../constants/constants";

import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { columnsConfigFor4007 } from "../../../constants/constants";

import "../infra.css";
import "../report.scss";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { useLocation } from "react-router-dom";
import { GlobalLoading } from "../../GlobalLoading/GlobalLoading";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../../Home/filter/FilterDropdownCommon358";
import { removeAllDistrict } from "../../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../../redux/slice/headerSlice";
import { handleMissingData } from "../../../utils/handleMissingData";
import satyamevaimg from "../../../assets/images/satyameva-jayate-img.png";
import udise from "../../../assets/images/udiseplu.jpg";
import nic from "../../../assets/images/nic-sm-logo.png";
import {
  TeacherGraph2008,
  TeacherGraph2009,
  TeacherGraph2010,
} from "../TeacherGraph2008";
import { ScrollToTopOnMount } from "../../Scroll/ScrollToTopOnMount";
import { Result } from "antd";

import useReportOverallRegionSum from "../../../CustomHook/useReportOverallRegionSum";
import Footer from "../../Header/Footer";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
export default function EnrolmentReport4007() {
  const dispatch = useDispatch();
  const location = useLocation();
  const schData = useSelector((state) => state?.cwsnEnrolment);
  const school_datas = useSelector((state) => state?.cwsnEnrolment?.data?.data);
  console.log('school_datas', school_datas)
  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  const schoolFilter = useSelector((state) => state.schoolFilter);
  const filterObj = structuredClone(schoolFilter);
  const headerData = useSelector((state) => state.header);
  const local_year = window.localStorage.getItem("year");
  const stateName = localStorage.getItem("state");
  const [groupKeys, setGroupKeys] = useState({
    schManagementBroad: false,
    schMgmtCenterDesc: false,
    schCategoryBroad: false,
    schCategoryIdDesc: false,
    schLocURDesc: false,
    category: true
  });

  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("map_state_name"));
    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [mgt, setMgt] = useState("");
  const [mgt_Details, setMgtDetail] = useState("");
  const [cat, setCat] = useState("");
  const [cat_Details, setCatDetail] = useState("");
  const [ur, setUR] = useState("");
  const [multiMgt, setMultiMgts] = useState("");
  const [multiCat, setMultiCats] = useState("");
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const [intialStudentData, setIntialStudentData] = useState(school_datas);
  const gridApiRef = useRef(null);
  const [activeTab, setActiveTab] = useState(type);
  const { t, i18n } = useTranslation();
  dispatch(handleActiveTabs(activeTab));
  useEffect(() => {
    setIntialStudentData(school_datas);
  }, [school_datas]);

  // Taking the both reports data condition wise for language change
  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  useEffect(() => {
    dispatch(allFilter(initialFilterEnrolmentData));
    dispatch(
      fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
    );
  }, [dispatch]);
  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [arrGroupedGraphData, setArrGroupedGraphData] = useState([]);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const filter_query_by_location =
    // local_state === "All India/National" ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";

  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },

    {
      headerName: "",
      children: [
        {
          headerName: "",
          children: [
            {
              headerName: "Location",
              field: "regionName",
              hide: !filter_query_by_location,
            },
            {
              headerName: "School Management(Broad)",
              field: "schManagementBroad",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Management(Detailed)",
              field: "schMgmtCenterDesc",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Category(Broad)",
              field: "schCategoryBroad",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
              headerName: "School Category(Detailed)",
              field: "schCategoryIdDesc",
              suppressColumnsToolPanel: true,
              hide: true,
            },
            {
                headerName: "Urban/Rural",
                field: "schLocURDesc",
                suppressColumnsToolPanel: true,
                hide: true,
              },
            {
                headerName: "Category",
                field: "category",
                suppressColumnsToolPanel: true,
                hide: false,
            },
           
          ],
        },
      ],
    },
    {
      headerName: "",
      children: [
      
        {
          headerName: "Balvatika-1",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp3G", hide: false },
            { headerName: "Boys", field: "pp3B", hide: false },
          ],
        },
        {
          headerName: "Balvatika-2",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp2G", hide: false },
            { headerName: "Boys", field: "pp2B", hide: false },
          ],
        },
        {
          headerName: "Balvatika-3",
          hide: false,
          children: [
            { headerName: "Girls", field: "pp1G", hide: false },
            { headerName: "Boys", field: "pp1B", hide: false },
          ],
        },
        {
          headerName: "Class-1",
          hide: false,
          children: [
            { headerName: "Girls", field: "c1G" },
            { headerName: "Boys", field: "c1B" },
          ],
        },
        {
          headerName: "Class-2",
          hide: false,
          children: [
            { headerName: "Girls", field: "c2G", hide: false },
            { headerName: "Boys", field: "c2B", hide: false },
          ],
        },
        {
          headerName: "Class-3",
          hide: false,
          children: [
            { headerName: "Girls", field: "c3G" },
            { headerName: "Boys", field: "c3B" },
          ],
        },
        {
          headerName: "Class-4",
          hide: false,
          children: [
            { headerName: "Girls", field: "c4G" },
            { headerName: "Boys", field: "c4B" },
          ],
        },
        {
          headerName: "Class-5",
          hide: false,
          children: [
            { headerName: "Girls", field: "c5G" },
            { headerName: "Boys", field: "c5B" },
          ],
        },
        {
          headerName: "Class-6",
          hide: false,
          children: [
            { headerName: "Girls", field: "c6G" },
            { headerName: "Boys", field: "c6B" },
          ],
        },
        {
          headerName: "Class-7",
          hide: false,
          children: [
            { headerName: "Girls", field: "c7G" },
            { headerName: "Boys", field: "c7B" },
          ],
        },
        {
          headerName: "Class-8",
          hide: false,
          children: [
            { headerName: "Girls", field: "c8G" },
            { headerName: "Boys", field: "c8B" },
          ],
        },
        {
          headerName: "Class-9",
          hide: false,
          children: [
            { headerName: "Girls", field: "c9G" },
            { headerName: "Boys", field: "c9B" },
          ],
        },
        {
          headerName: "Class-10",
          hide: false,
          children: [
            { headerName: "Girls", field: "c10G" },
            { headerName: "Boys", field: "c10B" },
          ],
        },
        {
          headerName: "Class-11",
          hide: false,
          children: [
            { headerName: "Girls", field: "c11G" },
            { headerName: "Boys", field: "c11B" },
          ],
        },
        {
          headerName: "Class-12",
          hide: false,
          children: [
            { headerName: "Girls", field: "c12G" },
            { headerName: "Boys", field: "c12B" },
          ],
        },

        {
          headerName: "Overall",
          hide: false,
          children: [
            {
              headerName: "Overall",
              field: "total",
              valueGetter: (params) => (params.data ? params.data.total : null),
              aggFunc: "sum",
            },
          ],
        },
      ],
    },
  ]);

  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    filter: true,
    autoHeaderHeight: true,
  });
  function onColumnVisible(event) {
    const columnId = event?.column?.colId;
    const visible = event.visible;
    if (columnId === "schManagementBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schManagementBroad: visible,
      }));
      setMgt(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schMgmtCenterDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schMgmtCenterDesc: visible,
      }));
      setMgtDetail(() => (visible ? "active" : ""));
      setMultiMgts(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryBroad: visible,
      }));
      setCat(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }
    if (columnId === "schCategoryIdDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryIdDesc: visible,
      }));
      setCatDetail(() => (visible ? "active" : ""));

      setMultiCats(() => (visible ? "multibtn" : ""));
    }

    if (columnId === "schLocURDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schLocURDesc: visible,
      }));
      setUR(() => (visible ? "active" : ""));
    }

    if (columnId === "category") {
        setGroupKeys((prev) => ({
          ...prev,
          category: visible,
        }));
        setMgt(() => (visible ? "active" : ""));
        setMultiMgts("multibtn");
      }
  }

  const onGridReady = (params) => {
    if (!params) {
      return;
    }
    gridApiRef.current = params?.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys)?.forEach((key) => {
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };
  const handleCustomKeyInAPIResponse = () => {
  
    const arr = [];
    school_datas?.forEach((item, idx) => {
      let appendedObj = { ...item };
      /* broad management key added*/
      if (state_gov_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "State Government";
      } else if (gov_aided_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Govt. Aided";
      } else if (pvt_uaided_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Private Unaided";
      } else if (ctrl_gov_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Central Government";
      } else if (other_mgt_code.includes((item.schMgmtCenterCode).toString())) {
        appendedObj.schManagementBroad = "Others";
      }
      /* broad category key added*/
      if (foundational_preparatory.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Foundational and Preparatory";
      } else if (middle.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Middle";
      } 
      else if (secondary.includes(item.schCategoryId)) {
        appendedObj.schCategoryBroad = "Secondary";
      } 
      
      //Add disability Category
      let disabilityDesc = disabilityDsc(item.disablityId);
      appendedObj.category = disabilityDesc;
    
    
      arr.push(appendedObj);
    });

    console.log('appendedObj', arr)

    setData(arr);
    ////console.log('dataa',data)
    setGraphData(arr);
  };

  const generateKey = (item, filters) => {
    ////console.log('filters', filters)
    const {
      regionName,
      schManagementBroad,
      schMgmtCenterDesc,
      schCategoryBroad,
      schCategoryIdDesc,
      schLocURDesc,
      category
    } = item;
    let keyParts = [regionName];

    if (filters.schManagementBroad) keyParts.push(schManagementBroad);
    if (filters.schMgmtCenterDesc) keyParts.push(schMgmtCenterDesc);
    if (filters.schCategoryBroad) keyParts.push(schCategoryBroad);
    if (filters.schCategoryIdDesc) keyParts.push(schCategoryIdDesc);
    if (filters.schLocURDesc) keyParts.push(schLocURDesc);
    if(category != null){
         keyParts.push(category);
         return keyParts.join("-");
    }

  };

  const groupData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      const key = generateKey(item, filters); 
      ////console.log(key,'generateKey');
      
    //   if(item.casteId==="5"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
    //   }
     
    });
     ////console.log(groupedData,'there');
     
    return Object.values(groupedData);
  };
  const handleButtonClick = (type, detailType) => {
    handleFilterClick(type, detailType);

    if (type === "School Management") {
      setMgt((prevMgt) =>
        detailType === "broad" ? (prevMgt === "active" ? "" : "active") : ""
      );
      setMgtDetail((prevMgtDetail) =>
        detailType === "desc"
          ? prevMgtDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }

    if (type === "School Category") {
      setCat((prevCat) =>
        detailType === "broad" ? (prevCat === "active" ? "" : "active") : ""
      );
      setCatDetail((prevCatDetail) =>
        detailType === "desc"
          ? prevCatDetail === "active"
            ? ""
            : "active"
          : ""
      );
    }
  };

  useEffect(() => {
    setColumn((prevColumns) => {
      const updatedColumns = [...prevColumns];
      const firstChild = updatedColumns[1].children[0].children;

      const updateColumnVisibility = (field, isVisible) => {
        const index = firstChild.findIndex((col) => col.field === field);
        if (index !== -1) {
          firstChild[index].hide = !isVisible;
        }
      };

      if (groupKeys.schManagementBroad !== undefined) {
        updateColumnVisibility(
          "schManagementBroad",
          groupKeys.schManagementBroad
        );
      }
      if (groupKeys.schMgmtCenterDesc !== undefined) {
        updateColumnVisibility(
          "schMgmtCenterDesc",
          groupKeys.schMgmtCenterDesc
        );
      }
      if (groupKeys.schCategoryBroad !== undefined) {
        updateColumnVisibility("schCategoryBroad", groupKeys.schCategoryBroad);
      }
      if (groupKeys.schCategoryIdDesc !== undefined) {
        updateColumnVisibility("schCategoryIdDesc", groupKeys.schCategoryIdDesc);
      }
      if (groupKeys.schLocURDesc !== undefined) {
        updateColumnVisibility("schLocURDesc", groupKeys.schLocURDesc);
      }
      if (groupKeys.category !== undefined) {
        updateColumnVisibility("category", groupKeys.category);
      }
      updateColumnVisibility("regionName", filter_query_by_location);
      const updatedDefs = updatedColumns.map((colGroup) => ({
        ...colGroup,
        children: colGroup.children?.map((col) => ({
          ...col,
          hide: firstChild.find((c) => c.field === col.field)?.hide || col.hide,
        })),
      }));

      return updatedDefs;
    });

    ////console.log('columns ',columns)

//     let sum=0;
//     for(let i=0 ;i< data?.length;i++){
//       // "1", "2", "3", "6", "89", "90", "91"
//       if(data[i].schCategoryId=="2"){
//       if(data[i].schMgmtCenterId=="1" || data[i].schMgmtCenterId=="2" || data[i].schMgmtCenterId=="3" || data[i].schMgmtCenterId=="6" || data[i].schMgmtCenterId=="89" || data[i].schMgmtCenterId=="90" || data[i].schMgmtCenterId=="91"){
//       ////console.log(i+"---"+data[i].totEnrPry)
// if(data[i].schMgmtCenterId=="1" && data[i].casteId == "0"){
//   ////console.log("Primary and Upper Primary "+data[i].c1B)
//   sum += parseInt(data[i].c1B);
// }

//       }
//     }
//   }
  
    const grouped = groupData(data, groupKeys);
    console.log('grouped', grouped)

    const filteredData = grouped.filter(item => item.category !== null); 
    const removeSpecialSymbol = filteredData.map((item) => {
      if(item.category === '-Intellectual Disability'){
          item.category = "Intellectual Disability"
      }
      return item
    })

    setArrGroupedData(removeSpecialSymbol);
    setColumnVisibility(removeSpecialSymbol);
  }, [groupKeys, data, filter_query_by_location, school_datas]);

  // using use effect to translate the data
  useEffect(() => {
    const translateColumns = (columnsArray) => {
      return columnsArray?.map((col) => ({
        ...col,
        headerName: t(col.headerNameKey),
        children: col.children ? translateColumns(col.children) : col.children,
      }));
    };

    const translatedColumns = translateColumns(columnsConfigFor4007);

    setColumn(translatedColumns);
  }, [t]);

  const handleFilterClick = (type, detailType) => {
    setGroupKeys((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (type === "School Management") {
        if (detailType === "broad") {
          newFilters.schManagementBroad = !prevFilters.schManagementBroad;
          newFilters.schMgmtCenterDesc = false;
        } else if (detailType === "desc") {
          newFilters.schMgmtCenterDesc = !prevFilters.schMgmtCenterDesc;
          newFilters.schManagementBroad = false;
        }
      } else if (type === "School Category") {
        if (detailType === "broad") {
          newFilters.schCategoryBroad = !prevFilters.schCategoryBroad;
          newFilters.schCategoryIdDesc = false;
        } else if (detailType === "desc") {
          // newFilters.schCategoryIdDesc = !prevFilters.schCategoryIdDesc;
          // newFilters.schCategoryBroad = false;
        }

      } 
      else if (type === "Urban/Rural") {
        newFilters.schLocURDesc = !prevFilters.schLocURDesc;
      }

      return newFilters;
    });
  };

  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };
  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Total" }
        : { regionName: "Total" }),
        pp1B: calculateTotal("pp1B"),
        pp1G: calculateTotal("pp1G"),
        pp2B: calculateTotal("pp2B"),
        pp2G: calculateTotal("pp2G"),
        pp3B: calculateTotal("pp3B"),
        pp3G: calculateTotal("pp3G"),
      c2G: calculateTotal("c2G"),
      c2B: calculateTotal("c2B"),
      c3G: calculateTotal("c3G"),
      c3B: calculateTotal("c3B"),
      c1G: calculateTotal("c1G"),
      c1B: calculateTotal("c1B"),
      c4G: calculateTotal("c4G"),
      c4B: calculateTotal("c4B"),
      c5G: calculateTotal("c5G"),
      c5B: calculateTotal("c5B"),
      c6G: calculateTotal("c6G"),
      c6B: calculateTotal("c6B"),
      c7G: calculateTotal("c7G"),
      c7B: calculateTotal("c7B"),
      c8B: calculateTotal("c8B"),
      c8G: calculateTotal("c8G"),
      c9B: calculateTotal("c9B"),
      c9G: calculateTotal("c9G"),
      c10B: calculateTotal("c10B"),
      c10G: calculateTotal("c10G"),
      c11G: calculateTotal("c11G"),
      c11B: calculateTotal("c11B"),
      c12B: calculateTotal("c12B"),
      c12G: calculateTotal("c12G"),
      // totEnrPryG: calculateTotal("totEnrPryG"),
      // totEnrPryB: calculateTotal("totEnrPryB"),
      // totEnrUPryG: calculateTotal("totEnrUPryG"),
      // totEnrUPryB: calculateTotal("totEnrUPryB"),
      // totEnrSecG: calculateTotal("totEnrSecG"),
      // totEnrSecB: calculateTotal("totEnrSecB"),
      // totEnrHSecG: calculateTotal("totEnrHSecG"),
      // totEnrHSecB: calculateTotal("totEnrHSecB"),
      // totEnrG: calculateTotal("totEnrG"),
      // totEnrB: calculateTotal("totEnrB"),
      // withoutPPrytotEnrG: calculateTotal("withoutPPrytotEnrG"),
      // withoutPPrytotEnrB: calculateTotal("withoutPPrytotEnrB"),
      // Correct total calculation
      total:
      calculateTotal("pp1B") +
      calculateTotal("pp1G") +
      calculateTotal("pp2B") +
      calculateTotal("pp2G") +
      calculateTotal("pp3B") +
      calculateTotal("pp3G") +
        calculateTotal("c2G") +
        calculateTotal("c3G") +
        calculateTotal("c1G") +
        calculateTotal("c2B") +
        calculateTotal("c3B") +
        calculateTotal("c1B") +
        calculateTotal("c4B") +
        calculateTotal("c4G") +
        calculateTotal("c5B") +
        calculateTotal("c5G") +
        calculateTotal("c6B") +
        calculateTotal("c6G") +
        calculateTotal("c7B") +
        calculateTotal("c7G") +
        calculateTotal("c8G") +
        calculateTotal("c8B") +
        calculateTotal("c9G") +
        calculateTotal("c9B") +
        calculateTotal("c10G") +
        calculateTotal("c10B") +
        calculateTotal("c11B") +
        calculateTotal("c11G") +
        calculateTotal("c12B") +
        // calculateTotal("totEnrPryG") +
        // calculateTotal("totEnrPryB") +
        // calculateTotal("totEnrUPryG") +
        // calculateTotal("totEnrUPryB") +
        // calculateTotal("totEnrSecG") +
        // calculateTotal("totEnrSecB") +
        // calculateTotal("totEnrHSecG") +
        // calculateTotal("totEnrHSecB") +
        // calculateTotal("totEnrG") +
        // calculateTotal("totEnrB") +
        // calculateTotal("withoutPPrytotEnrG") +
        // calculateTotal("withoutPPrytotEnrB") +
        calculateTotal("c12G"),
    },
  ];

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns?.map((column) => {
      const { field, headerName } = column?.getColDef();
      const sort = column?.getSort();
      const headerNameUppercase = field[0]?.toUpperCase() + field?.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const columns = gridApi?.api?.getAllDisplayedColumns();
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi?.api?.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      if (!columns) {
        return;
      }
      columns?.forEach((column) => {
        rowToExport?.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    if (!gridApi) {
      return;
    }
    const headerRow = getHeaderToExport(gridApi);
    const rows = getRowsToExport(gridApi);
    const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
    const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
    ? (pinedBottomRowDatas)
    : [];
    const pinnedBottomRow = pinnedBottomRowData
    const date = new Date();
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    if (pinnedBottomRow && pinnedBottomRow.length > 0) {
      pinnedBottomRow.forEach((row) => {
        const totalRow = headerRow.map((header) => {
          let field = header.text;
          if (row.hasOwnProperty(field.charAt(0).toLowerCase() + field.slice(1))) {
            field = field.charAt(0).toLowerCase() + field.slice(1);
          } else if (row.hasOwnProperty(field.charAt(0).toUpperCase() + field.slice(1))) {
            field = field.charAt(0).toUpperCase() + field.slice(1);
          }
          return row[field] !== undefined ? row[field].toString() : "";
        });
    
        table.push(totalRow);
      });
    }
    const headers = [];
    // First row: Social Category spanning all columns
    headers.push([
      {
        content: "",
        colSpan: table[0].length,
        styles: { halign: "center" },
      },
    ]);

    // Second row: Category headers
    const secondRow = [
      { content: "", colSpan: 1, styles: { halign: "center" } },
    ];
    columns[2].children.forEach((category) => {
      secondRow.push({
        content: category.headerName,
        colSpan: category.children.length,
        styles: { halign: "center" },
      });
    });

    const numberOfColumns = table[0].length;
    const baseValue = 10;
    const extraCells = numberOfColumns - baseValue;
    // Add empty cells to the start of secondRow
    if (extraCells > 0) {
      for (let i = 0; i < extraCells; i++) {
        secondRow.unshift({ content: "", colSpan: 1 });
      }
    }

    const thirdRow = [{ content: "", styles: { halign: "center" } }];
    table[0].forEach((header) => {
      thirdRow.push({ content: header, styles: { halign: "center" } });
    });
    thirdRow.shift();
    headers.push(secondRow);
    headers.push(thirdRow);

    addHeader();
    doc.autoTable({
      head: headers,
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
        halign: "center",
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;
        const columnHeaderHeaderName = headerRow[data.column.index]?.headerName;
        // Check if the current column header is "Serial Number"
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center";
        } else if (
          columnHeaderText === "RegionName" ||
          columnHeaderText === "Location"
        ) {
          data.cell.styles.halign = "left";
        } else if (
          columnHeaderText === "SchManagementBroad" ||
          columnHeaderText === "SchCategoryBroad" ||
          columnHeaderText === "SchTypeDesc" ||
          columnHeaderText === "schLocURDesc" ||
          columnHeaderText === "schMgmtCenterDesc" ||
          columnHeaderText === "schMgmtCenterDesc" ||
          columnHeaderText === "schCategoryIdDesc"
        ) {
          data.cell.styles.halign = "left";
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();
    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }
    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    if (!gridApi) {
      return;
    }
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };
  const exportToExcel = () => {
    if (gridApi) {
      const allData = [];
      const visibleColumns = gridApi?.api?.getAllDisplayedColumns();
      const columnHeaders = visibleColumns?.map((column) => ({
        headerName: column?.getColDef().headerName,
        field: column?.getColDef().field,
      }));
      columnHeaders?.unshift({
        headerName: "S.NO.",
        field: "Serial Number",
      });
      gridApi?.api?.forEachNode((node, index) => {
        const data = node.data;
        const rowDataWithSerial = { ...data, "Serial Number": index + 1 };
        allData.push(rowDataWithSerial);
      });

      console.log('allData', allData)
      const columnKeys = columnHeaders?.map((column) => column?.field);
      const columnNames = columnHeaders?.map((column) => column?.headerName);
      let rowIndexZero=true;
      gridApi?.api?.exportDataAsExcel({
        processHeaderCallback: (params) => {
          console.log(params.column?.getColId());
          if (params.column?.getColId() === 'Serial Number') {
            return 'S.No'; // Header name for the new column
          }
          return params.column.getColDef().headerName; // Default header names for existing columns
        },
        processCellCallback: (params) => {
          console.log('total--',params.api.getDisplayedRowCount());
          console.log('row index',params.node.rowIndex);
          if(params.node.rowIndex ==0 && rowIndexZero){
            rowIndexZero=false;
            if (params.column?.getColId() === 'Serial Number') {
              return params.node.rowIndex + 1; // Adding S.No values dynamically
            }
          }else if(params.node.rowIndex ==0 && rowIndexZero == false){
            if (params.column?.getColId() === 'Serial Number') {
              return ''; // Adding S.No values dynamically
            }
          }else{
            if (params.column?.getColId() === 'Serial Number') {
              return params.node.rowIndex + 1; // Adding S.No values dynamically
            }
          }
         
          console.log('params.value--[',params.value);
          return params.value; // Default value for existing columns
        },
        rowData: allData,
        fileName: report.report_name,
        sheetName: "Udise+",
        columnKeys: columnKeys,
        columnNames: columnNames,
      });
    }
  };
  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      if (!gridApi) {
        return;
      }
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };
  useEffect(() => {
    if (intialStudentData && intialStudentData.length > 0) {
      handleCustomKeyInAPIResponse();
    }
  }, [intialStudentData, school_datas, location.pathname]);
  //  ........................Graph code statr here.....................
  // ...Start Total No. of Teacher by School Management & School Category.....
  const generateKeyGraph = (item, filters) => {
    const { schManagementBroad, schCategoryBroad } = item;
    let keyParts = [schManagementBroad, schCategoryBroad];
    return keyParts.join("-");
  };

  const groupGraphData = (data, filters) => {
    const groupedData = {};

    data.forEach((item) => {
      const key = generateKeyGraph(item, filters);
      
      if(item.casteId==="5"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="6"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="7"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }

      if(item.casteId==="8"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
      if(item.casteId==="9"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
      if(item.casteId==="10"){
        if (!groupedData[key]) {
          groupedData[key] = {
            ...item,
            pp1B:0,
            pp1G:0,
            pp2B:0,
            pp2G:0,
            pp3B:0,
            pp3G:0,
            c2G: 0,
            c2B: 0,
            c3G: 0,
            c3B: 0,
            c1G: 0,
            c1B: 0,
            c4G: 0,
            c4B: 0,
            c5G: 0,
            c5B: 0,
            c6G: 0,
            c6B: 0,
            c7G: 0,
            c7B: 0,
            c8B: 0,
            c8G: 0,
            c9B: 0,
            c9G: 0,
            c10B: 0,
            c10G: 0,
            c11G: 0,
            c11B: 0,
            c12G: 0,
            c12B: 0,
            // totEnrPryG: 0,
            // totEnrPryB: 0,
            // totEnrUPryG: 0,
            // totEnrSecG: 0,
            // totEnrSecB: 0,
            // totEnrHSecG: 0,
            // withoutPPrytotEnrG:0,
            // withoutPPrytotEnrB:0,
            // totEnrHSecB: 0,
            // totEnrUPryB: 0,
            // totEnrG: 0,
            // totEnrB: 0
          };
        }
  
        groupedData[key].pp1B += (parseInt(item.pp1B, 10) + parseInt(item.pp1Trans, 10));
        groupedData[key].pp1G += parseInt(item.pp1G, 10);
        groupedData[key].pp2B += (parseInt(item.pp2B, 10) + parseInt(item.pp2Trans, 10));
        groupedData[key].pp2G += parseInt(item.pp2G, 10);
        groupedData[key].pp3B += (parseInt(item.pp3B, 10) + parseInt(item.pp3Trans, 10));
        groupedData[key].pp3G += parseInt(item.pp3G, 10);
        groupedData[key].c2G += parseInt(item.c2G, 10);
        groupedData[key].c2B += (parseInt(item.c2B, 10) + parseInt(item.c2Trans, 10));
        groupedData[key].c1G += parseInt(item.c1G, 10);
        groupedData[key].c1B += (parseInt(item.c1B, 10) + parseInt(item.c1Trans, 10));
        groupedData[key].c3G += parseInt(item.c3G, 10);
        groupedData[key].c3B += (parseInt(item.c3B, 10) + + parseInt(item.c3Trans, 10));
        groupedData[key].c4G += parseInt(item.c4G, 10);
        groupedData[key].c4B += (parseInt(item.c4B, 10) + parseInt(item.c4Trans, 10));
        groupedData[key].c5G += parseInt(item.c5G, 10);
        groupedData[key].c5B += (parseInt(item.c5B, 10) + parseInt(item.c5Trans, 10));
        groupedData[key].c6G += parseInt(item.c6G, 10);
        groupedData[key].c6B += (parseInt(item.c6B, 10) + parseInt(item.c6Trans, 10));
        groupedData[key].c7G += parseInt(item.c7G, 10);
        groupedData[key].c7B += (parseInt(item.c7B, 10) + parseInt(item.c7Trans, 10));
        groupedData[key].c8B += (parseInt(item.c8B, 10) + parseInt(item.c8Trans, 10));
        groupedData[key].c8G += parseInt(item.c8G, 10);
        groupedData[key].c9B += (parseInt(item.c9B, 10) + parseInt(item.c9Trans, 10));
        groupedData[key].c9G += parseInt(item.c9G, 10);
        groupedData[key].c10B += (parseInt(item.c10B, 10) + parseInt(item.c10Trans, 10));
        groupedData[key].c10G += parseInt(item.c10G, 10);
        groupedData[key].c11G += parseInt(item.c11G, 10);
        groupedData[key].c11B += (parseInt(item.c11B, 10) + parseInt(item.c11Trans, 10));
        groupedData[key].c12G += parseInt(item.c12G, 10);
        groupedData[key].c12B += (parseInt(item.c12B, 10) + parseInt(item.c12Trans, 10));
        // groupedData[key].totEnrPryG += parseInt(item.totEnrPryG, 10);
        // groupedData[key].totEnrPryB += parseInt(item.totEnrPryB, 10);
        // groupedData[key].totEnrUPryG += parseInt(item.totEnrUPryG, 10);
        // groupedData[key].totEnrUPryB += parseInt(item.totEnrUPryB, 10);
        // groupedData[key].totEnrSecG += parseInt(item.totEnrSecG, 10);
        // groupedData[key].totEnrSecB += parseInt(item.totEnrSecB, 10);
        // groupedData[key].totEnrHSecG += parseInt(item.totEnrHSecG, 10);
        // groupedData[key].withoutPPrytotEnrG += (parseInt(item.totEnrG, 10) - parseInt(item.totEnrPrePryG, 10));
        // groupedData[key].withoutPPrytotEnrB += (parseInt(item.totEnrB, 10) - parseInt(item.totEnrPrePryB, 10));
        // groupedData[key].totEnrHSecB += parseInt(item.totEnrHSecB, 10);
        // groupedData[key].totEnrG += parseInt(item.totEnrG, 10);
        // groupedData[key].totEnrB += parseInt(item.totEnrB, 10);
      }
     
    });

    return Object.values(groupedData);
  };

  useEffect(() => {
    const grouped = groupGraphData(data, groupKeys);
    setArrGroupedGraphData(grouped);
  }, [groupKeys, graphData, filter_query_by_location, school_datas]);

  //Code For Graph 1

  // Taking Objects for category and management
  const categoryTranslations = {
    "Primary (PRY)": t("categories_school.Primary (PRY)"),
    "Upper Primary (UPR)": t("categories_school.Upper Primary (UPR)"),
    "Higher Secondary (HSEC)": t("categories_school.Higher Secondary (HSEC)"),
    "Secondary (SEC)": t("categories_school.Secondary (SEC)"),
  };

  const managementTranslations = {
    "State Government": t("managements.State Government"),
    "Govt. Aided": t("managements.Govt. Aided"),
    "Private Unaided": t("managements.Private Unaided"),
    "Central Government": t("managements.Central Government"),
    Others: t("managements.Others"),
  };

  // function to translate the data dynamically
  const translateDataKeys = (
    data,
    categoryTranslations,
    managementTranslations
  ) => {
    return data.map((item) => ({
      ...item,
      schCategoryBroad:
        categoryTranslations[item.schCategoryBroad] || item.schCategoryBroad,
      schManagementBroad:
        managementTranslations[item.schManagementBroad] ||
        item.schManagementBroad,
    }));
  };

  const processGraphData = (data) => {
    const translatedData = translateDataKeys(
      data,
      categoryTranslations,
      managementTranslations
    );

    // Define categories and managements in Hindi
    const categories = Object.values(categoryTranslations);
    const managements = [
      { name: managementTranslations["State Government"], color: "#751539" },
      { name: managementTranslations["Govt. Aided"], color: "#E6694A" },
      { name: managementTranslations["Private Unaided"], color: "#F5BF55" },
      { name: managementTranslations["Central Government"], color: "#BCE263" },
      { name: managementTranslations["Others"], color: "#57C1BB" },
    ];
    const abbreviateCategory = (category) => {
      return category.replace(/\s*\([^)]*\)/, "");
    };

    const seriesData = managements.map((management) => ({
      name: management.name,
      data: categories.map((category) => {
        const total = translatedData
          .filter(
            (item) =>
              item.schCategoryBroad === category &&
              item.schManagementBroad === management.name
          )
          .reduce((acc, curr) => acc + curr.totalSchCatWise, 0);
        return total;
      }),
      color: management.color,
    }));

    const abbreviatedCategories = categories.map(abbreviateCategory);

    const abbreviatedSeriesData = seriesData.map((series) => ({
      ...series,
      name: series.name.replace("Government", "Govt."),
    }));

    return {
      categories: abbreviatedCategories,
      series: abbreviatedSeriesData,
    };
  };

  const graphScmSchData = processGraphData(arrGroupedGraphData);

  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
      );
    }
    if (headerData.activeTab === "graph") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(
        fetchArchiveServicesCWSNEnrolmentData(initialFilterEnrolmentData)
      );
    }
  }, [headerData.activeTab, dispatch]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.

  const arrGroupedDataTable = handleMissingData(arrGroupedData, columns).map(
    (item) => ({
      ...item,
      total:
      item.pp1B +
      item.pp1G +
      item.pp2B +
      item.pp2G +
      item.pp3B +
      item.pp3G +
        item.c2G +
        item.c3G +
        item.c1G +
        item.c2B +
        item.c3B +
        item.c1B +
        item.c4B +
        item.c4G +
        item.c5B +
        item.c5G +
        item.c6B +
        item.c6G +
        item.c7B +
        item.c7G +
        item.c8G +
        item.c8B +
        item.c9G +
        item.c9B +
        item.c10B +
        item.c11G +
        item.c11B +
        item.c12G +
        item.c12B +
        // item.totEnrPryG +
        // item.totEnrPryB +
        // item.totEnrUPryG +
        // item.totEnrUPryB +
        // item.totEnrSecG +
        // item.totEnrSecB +
        // item.totEnrHSecG +
        // item.withoutPPrytotEnrG +
        // item.withoutPPrytotEnrB +
        // item.totEnrHSecB +
        // item.totEnrG +
        // item.totEnrB +
        item.c10G,
    })
  );
  
const disabilityDsc = (disabilityId) => {
  let desc = "";
  if (disabilityId == "1") {
    desc = "Blindness";
  } else if (disabilityId == "2") {
    desc = "Low Vision";
  } else if (disabilityId == "3") {
    desc = "Hearing impairment";
  } else if (disabilityId == "4") {
    desc = "Speech and Language";
  } else if (disabilityId == "5") {
    desc = "Locomotor Disability";
  } else if (disabilityId == "6") {
    desc = "Mental illness";
  } else if (disabilityId == "7") {
    desc = "Specific Learning Disabilities";
  } else if (disabilityId == "8") {
    desc = "Cerebral palsy";
  } else if (disabilityId == "9") {
    desc = "Autism Spectrum Disorder";
  } else if (disabilityId == "10") {
    desc = "Multiple Disability incl. deaf, blindness";
  } else if (disabilityId == "11") {
    desc = "Leprosy Cured students";
  } else if (disabilityId == "12") {
    desc = "Dwarfism";
  } else if (disabilityId == "13") {
    desc = "-Intellectual Disability";
  } else if (disabilityId == "14") {
    desc = "Muscular Dystrophy";
  } else if (disabilityId == "15") {
    desc = "Chronic Neurological conditions";
  } else if (disabilityId == "16") {
    desc = "Multiple Sclerosis";
  } else if (disabilityId == "17") {
    desc = "Thalassemia";
  } else if (disabilityId == "18") {
    desc = "Haemophilia";
  } else if (disabilityId == "19") {
    desc = "Sickle Cell disease";
  } else if (disabilityId == "20") {
    desc = "Acid Attack victim";
  } else if (disabilityId == "21") {
    desc = "Parkinson’s disease";
  }

  return desc || null;
};

console.log('groupKeys', groupKeys)
  const result = useReportOverallRegionSum(arrGroupedDataTable);
  console.log("columns---",columns);


  const anyGroupKeyTrue = Object.values(groupKeys).some((value) => value === true);
  const pinnedBottomRowData = ((anyGroupKeyTrue || (local_state !== "All India/National")) && ((anyGroupKeyTrue || (local_state === "State Wise")) || (anyGroupKeyTrue || (local_district === "District Wise")) || (anyGroupKeyTrue || (local_block === "Block Wise"))))
  ? (  pinedBottomRowDatas)
  : [];
  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      {schData.isLoading && <GlobalLoading />}
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")}
                          {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>

                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {" "}
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {t("download_as_pdf")}{" "}
                          </option>
                          <option value="export_excel">
                            {" "}
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
            {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">
                    {" "}
                    {t("view_data_by")}
                  </div>
                  <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiMgt}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active ${mgt}`}
                        onClick={(e) =>
                          handleButtonClick("School Management", "broad", e)
                        }
                      >
                        {t("school_management_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active details-multi ${mgt_Details}`}
                        id="school_mgt_details"
                        onClick={(e) =>
                          handleButtonClick("School Management", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                    {/* <li className={`nav-item ${multiCat}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active1 ${cat}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "broad", e)
                        }
                      >
                        {t("school_category_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active1 details-multi ${cat_Details}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li> */}
                    {/* <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${ur}`}
                        onClick={(e) =>
                          handleButtonClick("Urban/Rural", "broad", e)
                        }
                      >
                        {t("urban_rural")}
                      </button>
                    </li> */}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph">
            <div className="row align-items-center report-inner-tab">
              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")} <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}
                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p>The "Enrolment by Location, School Category, and School Management for Each Class & Level of Education by Minority" refers to the detailed analysis of student enrolment patterns, specifically focusing on minority groups, across various educational locations, school categories, and management types. This data provides a comprehensive view of how students from minority communities are distributed across different types of schools and educational levels.

Location in this context refers to the geographical area where the school is located, such as urban or rural regions, and even more localized areas like districts or states. This classification helps to identify whether minority students are concentrated in specific areas or if they have equitable access to education across different locations.<br />

School category refers to the level of education offered, such as primary, upper primary, secondary, or higher secondary schools. It allows for an understanding of whether minority students are enrolling at different stages of education, and if there are specific educational levels where their enrolment might be higher or lower.<br />

School management includes the types of schools—government-run, private, government-aided, or others. This classification helps assess how minority students are distributed between public and private institutions, and whether certain management types are more inclusive or accessible to these communities.<br />

Finally, the data is broken down by minority, which refers to students from minority communities, including linguistic, religious, or cultural minorities. This segmentation ensures that the enrolment figures specifically reflect the participation of these groups, which is crucial for assessing the effectiveness of educational policies aimed at promoting inclusion and equity.<br />

By analyzing this data, policymakers can better understand the enrolment trends of minority students, identify regions or school types that may need more support, and develop targeted strategies to increase minority participation in education. It also helps in assessing whether minority communities have equal access to quality education at all levels and in various school management systems, thus supporting efforts to reduce disparities and promote inclusive education for all.
</p>
                    </div>
                  </Tab>
                  <Tab eventKey="table" title={t("table")}>
                    <div className="multi-header-table">
                      <div
                        className=" multi-header-table ag-theme-quartz ag-theme-custom-height h-300"
                        style={{ height: 450 }}
                      >
                        <AgGridReact
                          key={gridRefreshKey}
                          rowData={
                            filter_query_by_location &&
                            (groupKeys.schManagementBroad ||
                              groupKeys.schMgmtCenterDesc ||
                              groupKeys.schCategoryBroad ||
                              groupKeys.schCategoryIdDesc ||
                              groupKeys.schLocURDesc ||
                              groupKeys.category)
                              ? result
                              : arrGroupedDataTable
                              ? arrGroupedDataTable
                              : []
                          }

                          
                        getRowStyle={(params) => {
                          if (params.data.isTotalRow) {
                            return { fontWeight: 'bold' };  // Apply inline bold style for totals row
                          }
                          return {};  // Default style for other rows
                        }}
                          columnDefs={columns}
                          defaultColDef={defColumnDefs}
                          onColumnVisible={onColumnVisible}
                          onGridReady={onGridReady}
                          groupDisplayType="custom"
                          groupHideOpenParents={true}
                          pinnedBottomRowData={pinnedBottomRowData}
                        />
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="graph" title={t("chart")} disabled>
                    <div className="card-box-impact tab-for-graph report-2008 mt-4 tab-content-reduce">
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <TeacherGraph2008 graphScmSchData={graphScmSchData} />
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <TeacherGraph2009 graphData={graphData} />
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <TeacherGraph2010 graphData={graphData} />
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <FilterDropdownCommom358 />
    </>
  );
}
